import "keen-slider/keen-slider.min.css";
import React from "react";
import { CasestudyCard, casestudyCards } from ".";
import NewLayout from "@components/new-ui/Layout";

import { CaseStudyHerosection, CaseStudyInformation, FeatureList, Navbar, navLinks, OrganizationProfile } from "./alrannan-administrative-services";
import StatsInfo from "@components/new-ui/IndustriesSection/StatsInfo";

const PanamaxInfotech: React.FC = () => {
    return (
        <NewLayout
            title="Panamax Infotech Boosts Growth Through Smarter Conversations"
            description="Learn how Panamax Infotech streamlined customer communication, automated support, and improved team productivity with Gallabox's WhatsApp solutions."
            canonical="https://gallabox.com/case-study/panamax-infotech"
            ogAttributes={{ image: "https://assets.gallabox.com/gb-home/case-study/panamax-og.png" }}
        >
            <CaseStudyHerosection
                title="How Panamax Infotech streamlined customer support with Gallabox"
                description="Learn how Panamax Infotech streamlined customer communication, automated support, and improved team productivity with Gallabox's WhatsApp solutions."
                imageUrl={"https://assets.gallabox.com/gb-home/case-study/panamax.svg"}
                redirectUrl={"/case-study"}
            />

            <StatsInfo
                statsInfo={[
                    { percentage: "70%", label: "Overall improvement in business growth" },
                    { percentage: "8%", label: "Increase in lead generation" },
                    { percentage: "10%", label: "Reduction in marketing and advertising spend" },
                ]}
            />
            <section className="max-w-6xl mx-auto  md:grid md:grid-cols-6 mt-24 mb-24">
                <div className="bg-white col-span-1">
                    <div style={{ position: "sticky", top: "100px" }}>
                        <OrganizationProfile
                            companyProfileData={[
                                { label: "Company", value: ["Panamax Infotech"] },
                                { label: "Industry", value: ["Service"] },
                            ]}
                            product={{
                                title: "Features used",
                                productLink: [
                                    { link: "https://gallabox.com/whatsapp-broadcast", label: "Broadcasts" },
                                    { link: "https://gallabox.com/whatsapp-chatbot", label: "Chatbots" },
                                    { link: "https://gallabox.com/whatsapp-flows", label: "Flows" },
                                    { link: "https://gallabox.com/whatsapp-integrations", label: "Integrations" },
                                ],
                            }}
                        />
                    </div>
                </div>
                <div className=" col-span-4 md:pl-8 px-4">
                    <div className="flex flex-col gap-y-12">
                        <section id="About">
                            <CaseStudyInformation mainTitle={"About Panamax Infotech"} className="mt-0" />
                            <p className="mt-2">
                                Panamax Infotech is a technology solutions company that delivers innovative IT and business services to clients worldwide. With a growing customer
                                base, the company wanted to improve the way it managed communications and ensure customer queries were handled quickly and efficiently.
                            </p>
                        </section>

                        <section id="Challenges">
                            <CaseStudyInformation
                                subTitle={"Challenges before Gallabox"}
                                descriptions={[
                                    "Panamax Infotech managed customer support primarily through chat and email. While these channels allowed real-time communication, they presented several challenges:",
                                ]}
                                className="mt-0"
                            />
                            <FeatureList
                                List={[
                                    { listItem: "High manual workload: The team had to respond to each query manually, which slowed down response times." },
                                    { listItem: "Limited scalability: As the customer base grew, managing multiple conversations simultaneously became increasingly difficult." },
                                    {
                                        listItem:
                                            "Lack of automation: Routine queries consumed valuable employee time, leaving little room to focus on strategic or complex client needs.",
                                    },
                                ]}
                                className="mt-5 bg-gray-100"
                            />
                            <CaseStudyInformation
                                subTitle={"Initial solutions tried"}
                                descriptions={["Before adopting Gallabox, Panamax Infotech primarily used:"]}
                                className="mt-12"
                            />
                            <FeatureList
                                List={[
                                    { listItem: "Support Chat to handle customer questions in real time." },
                                    { listItem: "Email as the primary tool for follow-ups and support." },
                                ]}
                                className="mt-5 bg-gray-100"
                            />
                            <p className="mt-5">
                                While these solutions were functional, they lacked automation and integration, which meant the process was not sustainable for growth.
                            </p>
                        </section>

                        <section id="Solutions">
                            <CaseStudyInformation
                                subTitle={"Why Panamax Infotech chose Gallabox"}
                                descriptions={[
                                    "Panamax selected Gallabox because of its intuitive WhatsApp design that made customer interactions seamless and professional. The team found Gallabox's interface simple to use, while its automation features promised efficiency and scalability. Gallabox offered an all-in-one platform that could replace disjointed tools and allow the company to focus on growth.",
                                    "With Gallabox, Panamax set clear objectives:",
                                ]}
                                className="mt-0"
                            />
                            <FeatureList
                                List={[
                                    { listItem: "Streamline customer communication to reduce delays and provide timely responses." },
                                    { listItem: "Automate support workflows so repetitive queries were handled instantly." },
                                    { listItem: "Improve team productivity by reducing manual tasks." },
                                    { listItem: "Enhance lead generation and conversion by ensuring no customer was left unattended." },
                                ]}
                                className="mt-5 bg-gray-100"
                            />
                        </section>

                        <section id="Impact">
                            <CaseStudyInformation
                                subTitle={"Impact on business growth"}
                                descriptions={["The adoption of Gallabox delivered measurable results for Panamax Infotech:"]}
                                className="mt-0"
                            />
                            <FeatureList
                                List={[
                                    { listItem: "A 70% overall improvement in business growth." },
                                    { listItem: "8% increase in lead generation, thanks to improved communication workflows." },
                                    { listItem: "10% improvement in first-time customer conversions, driven by faster responses." },
                                    { listItem: "10% reduction in marketing and advertising spend, due to more efficient use of resources." },
                                ]}
                                className="mt-5 bg-gray-100"
                            />

                            <CaseStudyInformation
                                subTitle={"Turning conversations into growth opportunities"}
                                descriptions={[
                                    "Gallabox has helped Panamax Infotech modernize its customer communication workflows, moving beyond traditional support chat and email. By introducing automation through chatbots, flows, broadcasts, and seamless integrations, the company has been able to improve lead generation, optimize conversions, and reduce marketing costs.",
                                    "With measurable growth across multiple business metrics and a user-friendly design tailored for WhatsApp, Panamax Infotech continues to rely on Gallabox as a trusted partner in strengthening client relationships and scaling customer support efficiently.",
                                ]}
                                className="mt-10"
                            />
                        </section>
                    </div>
                </div>
                <div>
                    <div style={{ position: "sticky", top: "100px", minHeight: "510px" }} className="hidden md:block">
                        <Navbar links={navLinks} />
                    </div>
                </div>
            </section>
            <section className="max-w-6xl mx-auto">
                <h3 className="text-gray-900 mb-10 mt-5 text-left ml-4">Check out other customer stories</h3>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 max-w-6xl mx-auto mb-20">
                    {casestudyCards.slice(0, 3)?.map((data, index) => (
                        <CasestudyCard key={index} {...data} />
                    ))}
                </div>
            </section>
        </NewLayout>
    );
};

export default PanamaxInfotech;
